import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

import { roomQueries } from '@/entities/room'
import { isHttpError } from '@/shared/api'
import { useServerErrorHandler } from '@/shared/config'

export const useGetContractRoom = () => {
  const [isLoading, setIsLoading] = useState(false)

  const queryClient = useQueryClient()
  const { handleServerError } = useServerErrorHandler()

  const getContractRoom = async (roomId: number, contractId: number) => {
    setIsLoading(true)

    try {
      const res = await queryClient.fetchQuery({
        ...roomQueries.contractRoom({ roomId, contractId }),
        meta: {
          useCustomHandling: true,
        },
      })

      return {
        response: res,
        error: null,
      }
    } catch (error) {
      if (isHttpError(error)) {
        handleServerError(error.handler)
      }

      return {
        response: null,
        error,
      }
    } finally {
      setIsLoading(false)
    }
  }

  return { getContractRoom, isLoading }
}
